import { Employee, OperationAttainment } from '../../types/interfaces';
import {
  attainmentsFromOperations,
  mapEmployeeAttainments as mapEmployeeAttainmentsCore,
  type WorkOrderTimeframe
} from '../attainmentAvailability';


export function mapEmployeeAttainments(
  employees: Employee[],
  attainments: OperationAttainment[],
  timeframe?: WorkOrderTimeframe
): Employee[] {
  return mapEmployeeAttainmentsCore(
    employees,
    attainmentsFromOperations(attainments),
    timeframe
  );
}
